module.exports = "<div class=\"modal-header text-right\"> <button class=\"sw-btn sw-btn-default--link\" type=button ng-click=cancel()>{{:: T.CLOSE }}</button> </div> <div class=modal-body> <div class=row> <div class=\"col-md-12 col-lg-12\"><h2>{{:: T.PRIVACY_TITLE_COOKIES }}</h2></div> <div class=\"col-md-12 col-lg-12\"><span>{{:: T.PRIVACY_BODY_COOKIES }}</span></div> <hr> <div class=\"col-md-12 col-lg-12\"><h2>{{:: T.PRIVACY_TITLE_ANALYTICS }}</h2></div> <div class=\"col-md-12 col-lg-12\"><span>{{:: T.PRIVACY_BODY_ANALYTICS }}</span></div> </div> </div> ";


//////////////////
// WEBPACK FOOTER
// ./src/app/views/app.privacy/appPrivacy.html
// module id = 1048
// module chunks = 0